import { useEffect }                from 'react';
import { store }                    from 'index';
import { groupUrl }                 from 'utils/constants'
import { GET_WHATSAPP_STATUS_SAGA } from 'actions';

const useGetWhatsappStatus = (guest: boolean) => {

    const state               = store.getState();
    const { userInfo }        = state.data;
    const { dataUpdateState } = state.data;

    useEffect(() => {

        if ( groupUrl || guest || userInfo.subscriptionExpired || userInfo.userEmail.length === 0 || dataUpdateState.final !== true ) {
          return
        }

        store.dispatch(GET_WHATSAPP_STATUS_SAGA(userInfo.userEmail));

    },[ userInfo, dataUpdateState, guest ])

    


}
export default useGetWhatsappStatus;

